<template>
  <legend v-html="legend" />
</template>
<script>
export default {
  name: 'FormLegend',
  props: {
    field: Object,
  },
  computed: {
    legend() {
      let labelVal = this.field.label ? this.field.label : '';
      let labelKey = this.field.label ? this.field.label.replace(':', '') : '';
      let label = this.labelKey && this.$te(labelKey) ? this.$t(labelKey) : labelVal;
      return label + (this.field.required ? `<span class='error--text required'> *</span>` : '');
    },
  },
};
</script>
<style scoped>
legend {
  font-weight: 600;
}
.required {
  font-size: 14px;
  transform: translateY(-15px);
}
</style>
